<template>
  <div>
    <label  class="switch">
      <input  v-model="model" type="checkbox" @click="$emit('click')">
      <span :style="{'--toggleColor': color}" class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'app-toggle',
  data: () => ({
    model: false,
  }),
  props: {
    value: {},
    color: {
      type: String,
      default: '#36A3CA',
    },
  },
  watch: {
    model(oldValue) {
      this.$emit('input', oldValue);
    },
  },
  mounted() {
    this.model = this.value;
  },
};
</script>

<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked+.slider {
  background-color: var(--toggleColor);
}

input:focus+.slider {
  box-shadow: 0 0 1px var(--toggleColor);
}

input:checked+.slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 28px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
